"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, r, n, a, o, c) {
  try {
    var u = e[o](c),
      i = u.value;
  } catch (e) {
    return void r(e);
  }
  u.done ? t(i) : Promise.resolve(i).then(n, a);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (n, a) {
      var o = e.apply(t, r);
      function c(e) {
        asyncGeneratorStep(o, n, a, c, u, "next", e);
      }
      function u(e) {
        asyncGeneratorStep(o, n, a, c, u, "throw", e);
      }
      c(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var BUBBLE_API_HOST2 = "https://api2.getmybubble.io",
  LifeScore = function () {
    return _createClass(function e() {
      _classCallCheck(this, e);
    }, [{
      key: "getImageBlob",
      value: (r = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var r = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.getAddressDetails(t, "jsonOutput").then(function (e) {
                return r.getLifeScore(e).then(function (e) {
                  return r.createimg(t.fontsize, t.fontcolor, e, t.width, t.height, t.fontweight, t.fontfamily);
                });
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getAddressDetails",
      value: (t = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var r,
          n,
          a = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = a.length > 1 && void 0 !== a[1] ? a[1] : "address", n = "".concat(BUBBLE_API_HOST2, "/fetch1?data_category=ZipCityCountyState&version=v1&dget1=").concat(t.targetZip), console.log("Before fetch:theUrl:", n), e.abrupt("return", fetch(n).then(function (e) {
                return e.json();
              }).then(function (e) {
                var t = JSON.parse(e.output);
                return "address" == r ? t.dput5 + ", " + t.dput2 : "all" == r ? t : {
                  get1: t.put1,
                  get2: t.put2
                };
              }).catch(function (e) {
                return "address" == r ? "Palo Alto, CA" : {
                  get1: "1119184147192197080178223133165133119104187217158227236",
                  get2: "1103152"
                };
              }));
            case 4:
            case "end":
              return e.stop();
          }
        }, e);
      })), function (e) {
        return t.apply(this, arguments);
      })
    }, {
      key: "getLifeScore",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var r,
          n = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = "".concat(BUBBLE_API_HOST2, "/fetch1?data_category=LifeScore&version=v6&get1=").concat(t.get1, "&get2=").concat(t.get2, "&get3=1087140082128153&get4=1084"), e.abrupt("return", fetch(r).then(function (e) {
                return e.json();
              }).then(function (e) {
                var t = JSON.parse(e.output);
                return n.getDecryptedJsonData(t).put1;
              }).catch(function (e) {
                return "942";
              }));
            case 2:
            case "end":
              return e.stop();
          }
        }, e);
      })), function (t) {
        return e.apply(this, arguments);
      })
    }, {
      key: "createimg",
      value: function (e, t, r, n, a, o, c) {
        var u = 50,
          i = 50,
          s = "Arial",
          f = "normal";
        null != a && (u = a), null != n && (i = n), null != o && (f = o), null != c && (s = c);
        var l = document.createElement("canvas");
        l.width = Number(i), l.height = Number(u);
        var p = l.getContext("2d");
        p.createLinearGradient(0, 0, l.width, 0), p.font = e + "px " + s, p.fontweight = f, p.fillStyle = t;
        var g = r;
        p.fillText(g, 1, 25);
        var h = document.createElement("img");
        return h.src = l.toDataURL(), console.log(h), h;
      }
    }, {
      key: "getDecryptedJsonData",
      value: function (e) {
        var t = e;
        for (var r in e) "id" == r || r.includes("dput") || (t[r] = this.getDecryptedData(e[r]));
        return t;
      }
    }, {
      key: "getDecryptedData",
      value: function (e) {
        return exports.decryptCodes(exports.getNumberArrayFrom(e));
      }
    }]);
    var e, t, r;
  }();
module.exports = {
  LifeScore: LifeScore
};